import { ThemeConfig } from 'antd';

import { ThemeMode, ThemeVariables } from '@/interfaces/theme';

export const KEY_LOCAL_STORAGE = 'nutror-xp-theme-mode';

export const THEME_CLASS_GLOBAL_MAP = {
  light: 'theme-light',
  dark: 'theme-dark'
};

export function setGlobalClassTheme(mode: ThemeMode) {
  const root = window.document.documentElement;
  root.classList.remove(THEME_CLASS_GLOBAL_MAP.light, THEME_CLASS_GLOBAL_MAP.dark);
  root.classList.add(mode === 'dark' ? THEME_CLASS_GLOBAL_MAP.dark : THEME_CLASS_GLOBAL_MAP.light);

  const metaThemeColor = document.querySelector('meta[name=theme-color]');

  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', mode === 'dark' ? '#000000' : '#ffffff');
  }
}

export function setInitialGlobalClassTheme() {
  const mode = window.localStorage.getItem(KEY_LOCAL_STORAGE) === 'light' ? 'light' : 'dark';
  setGlobalClassTheme(mode);
}
export function remapThemeColorPrimary(theme: ThemeConfig & { variables: ThemeVariables }, colorPrimary: string) {
  return {
    ...theme,
    token: {
      ...theme.token,
      colorPrimary: colorPrimary ?? theme.token.colorPrimary
    }
  };
}
